<template>
  <div v-if="!$store.getters.gameType" class="loading" />
  <div v-else>
    <div class="account_detail_area account_area d-grid">
      <div class="account_wrap">
        <div class="account_wrap-container">
          <h5 class="account_title">
            {{ $t("Bao.game_record") }}
          </h5>
          <button class="account_btn_get" @click="clickToogleAccountQuick()">
            <span class="text">{{ selectedDay }}</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="18"
              viewBox="0 0 20 18"
              class="icon"
            >
              <g
                id="组_1755"
                data-name="组 1755"
                transform="translate(-363 -150)"
              >
                <rect
                  id="矩形_1303"
                  data-name="矩形 1303"
                  width="20"
                  height="4"
                  transform="translate(363 150)"
                  fill="#f7a01b"
                />
                <rect
                  id="矩形_1304"
                  data-name="矩形 1304"
                  width="16"
                  height="4"
                  transform="translate(367 157)"
                  fill="#f7a01b"
                />
                <rect
                  id="矩形_1305"
                  data-name="矩形 1305"
                  width="12"
                  height="4"
                  transform="translate(371 164)"
                  fill="#f7a01b"
                />
              </g>
            </svg>
          </button>
          <div class="position-relative">
            <div class="quick_btn_wrap pc">
              <ul class="quick_btn_area eight list-unstyled">
                <li>
                  <button class="btn btn_quick d-flex align-items-center justify-content-center w-100" :class="{'active': beforeDay === 0}" @click="switchDay(0)">
                    {{ $t("Bao.today") }}
                  </button>
                </li>
                <li>
                  <button class="btn btn_quick d-flex align-items-center justify-content-center w-100" :class="{'active': beforeDay === 1}" @click="switchDay(1)">
                    {{ $t("Bao.yesterday") }}
                  </button>
                </li>
                <li>
                  <button class="btn btn_quick d-flex align-items-center justify-content-center w-100" :class="{'active': beforeDay === 2}" @click="switchDay(2)">
                    {{ $t("Bao.2_days_ago") }}
                  </button>
                </li>
                <li>
                  <button class="btn btn_quick d-flex align-items-center justify-content-center w-100" :class="{'active': beforeDay === 3}" @click="switchDay(3)">
                    {{ $t("Bao.3_days_ago") }}
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <!-- <div class="position-relative">
            <div class="quick_btn_wrap">
              <ul class="quick_btn_area eight list-unstyled">
                <li>
                  <button v-if="gameType == 'all'" class="btn btn_quick d-flex align-items-center justify-content-center w-100 active" @click="clickGameType('all')">
                    {{ $t("Bao.all") }}
                  </button>
                  <button v-else class="btn btn_quick d-flex align-items-center justify-content-center w-100" @click="clickGameType('all')">
                    {{ $t("Bao.all") }}
                  </button>
                </li>
                <li v-for="(item, key) in this.$store.getters.gameType" :key="key">
                  <button v-if="item.game_type == gameType" class="btn btn_quick d-flex align-items-center justify-content-center w-100 active" @click="clickGameType(item.game_type)">
                    {{ item.name }}
                  </button>
                  <button v-else class="btn btn_quick d-flex align-items-center justify-content-center w-100" @click="clickGameType(item.game_type)">
                    {{ item.name }}
                  </button>
                </li>
              </ul>
            </div>
            <button class="btn btn_arrow position-absolute" type="button">
              <i class="icon-keyboard_arrow_right" />
            </button>
          </div>
          <div class="account_range d-flex align-items-center justify-content-between">
            <span class="account_block_date d-flex align-items-center">
              <h5 class="account_range_title mb-0">
                {{ $t("Bao.date") }}
              </h5>
              <div class="account_slt_area position-relative">
                <datePicker v-model="dateRange" :limit-tree-day="true" @query="oneQuery" />
              </div>
            </span>
            <span class="account_block_status d-flex align-items-center">
              <h5 class="account_range_title mb-0">
                {{ $t("Bao.status") }}
              </h5>
              <div class="account_slt_area position-relative">
                <select v-model="status" class="account_range_date" @change="oneQuery">
                  <option value="all">
                    {{ $t("Bao.all") }}
                  </option>
                  <option v-for="(item, key) in gameBetStatus" :key="key" :value="key">
                    {{ item }}
                  </option>
                </select>
              </div>
            </span>
          </div> -->
          <div class="table_account_data">
            <span v-if="record.length !== 0">
              <table class="account_data_inner table mb-0">
                <thead>
                  <tr>
                    <th>
                      {{ $t("Bao.order_number") }}
                    </th>
                    <th>
                      {{ $t("Bao.bet_time") }}
                    </th>
                    <th>
                      {{ $t("Bao.game_finish_at") }}
                    </th>
                    <th>
                      {{ $t("Bao.plateform_name") }}
                    </th>
                    <th>
                      {{ $t("Bao.bet_amount") }}
                    </th>
                    <th>
                      {{ $t("Bao.game_winlose") }}
                    </th>
                    <th>
                      {{ $t("Bao.status") }}
                    </th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="record.length == 0 && !loading && !firstLoad">
                    <td colspan="9" class="text-center">
                      {{ $t("Bao.no_data") }}
                    </td>
                  </tr>
                  <tr v-for="(item, key) in record" v-else :key="key">
                    <td :data-title="$t('Bao.order_number')">
                      {{ getOrderNumber(item.id) }}
                    </td>
                    <td :data-title="$t('Bao.bet_time')">
                      {{ item.created_at | fullDateTimeFormat }}
                    </td>
                    <td :data-title="$t('Bao.game_finish_at')">
                      <template v-if="item.finish_at">
                        {{ item.finish_at | fullDateTimeFormat }}
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                    <td :data-title="$t('Bao.plateform_name')">
                      {{ item.game_provider_name }}
                      <!--<br> {{ item.game_name }}-->
                    </td>
                    <td :data-title="$t('Bao.bet_amount')">
                      {{ item.bet_amount }}
                    </td>
                    <td :data-title="$t('Bao.game_winlose')">
                      {{ item.bet_result }}
                    </td>
                    <td :data-title="$t('Bao.status')">
                      {{ item.status_label }}
                    </td>
                    <td>
                      <button class="btn btn_orderinfo" @click="showModal(item)">
                        {{ $t("Bao.order_detail") }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </span>
            <div v-if="record.length === 0 && !loading && !firstLoad" class="text-center no-data-area">
              <img width="258" src="@/assets/images/no_record_data.png">
              <h5>{{ $t('Bao.no_relevant_data_records') }}</h5>
              <span>{{ $t('Bao.search_results_are_empty') }}</span>
            </div>
            <scroll-loader :loader-method="query" :loader-disable="!enableAutoLoad" />
          </div>
        </div>
      </div>
    </div>
    <div v-show="showAccountQuick" class="account_quick">
      <div class="btn_done">
        <button class="btn_cross" @click="closeAccountQuick()">
          Done
        </button>
      </div>
      <ul class="list_info list-unstyled">
        <li>
          <a class=" " @click="switchDay(0, $t('Bao.today'))">{{ $t("Bao.today") }}</a>
        </li>

        <li>
          <a class=" " @click="switchDay(1, $t('Bao.yesterday'))">{{ $t("Bao.yesterday") }}</a>
        </li>

        <li>
          <a class=" " @click="switchDay(2, $t('Bao.2_days_ago'))">{{ $t("Bao.2_days_ago") }}</a>
        </li>

        <li>
          <a class=" " @click="switchDay(3, $t('Bao.3_days_ago'))">{{ $t("Bao.3_days_ago") }}</a>
        </li>
      </ul>
    </div>
    <b-modal
      id="modal_bet_detail"
      ref="modal_bet_detail"
      modal-class="modal modal_bet_detail modal_wallet fade"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      footer-class="modal-footer justify-content-center border-top-0"
      header-class="modal-header justify-content-center align-items-center border-bottom-0"
      body-class="modal-body"
      dialog-class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md"
    >
      <template v-slot:modal-header>
        <h4 class="mb-0">
          <b>{{ $t("Bao.order_detail") }}</b>
        </h4>
        <button type="button" class="close rounded-circle m-0" aria-label="Close" @click="$bvModal.hide('modal_bet_detail')">
          <i class="icon-clear" />
        </button>
      </template>
      <div>
        <table class="modal-table">
          <tr>
            <td>{{ $t('Bao.order_number') }}</td>
            <td>{{ getOrderNumber(betDetail.id) }}</td>
          </tr>
          <tr>
            <td>{{ $t('Bao.bet_time') }}</td>
            <td>{{ betDetail.created_at | dateTimeFormat }}</td>
          </tr>
          <tr>
            <td>{{ $t('Bao.game_finish_at') }}</td>
            <td>
              <template v-if="betDetail.finish_at">
                {{ betDetail.finish_at | dateTimeFormat }}
              </template>
              <template v-else>
                -
              </template>
            </td>
          </tr>
          <tr>
            <td>{{ $t('Bao.plateform_name') }}</td>
            <td>{{ betDetail.game_provider_name }}</td>
          </tr>
          <tr>
            <td>{{ $t('Bao.game_name') }}</td>
            <td>{{ betDetail.game_name }}</td>
          </tr>
          <tr>
            <td>{{ $t('Bao.total_bet_amount') }}</td>
            <td>{{ betDetail.bet_amount | numberFormat }}</td>
          </tr>
          <tr>
            <td>{{ $t('Bao.game_winlose') }}</td>
            <td>{{ betDetail.bet_result | numberFormat }}</td>
          </tr>
          <tr>
            <td>{{ $t('Bao.profit_and_loss') }}</td>
            <td>0</td>
          </tr>
          <tr>
            <td>{{ $t('Bao.status') }}</td>
            <td>{{ betDetail.status_label }}</td>
          </tr>
        </table>
      </div>
      <template v-slot:modal-footer>
        <div class="wallet_transfer_btn modal_btns d-flex justify-content-center w-100">
          <button type="button" class="btn btn_transfer text-white" aria-label="Close" @click="$bvModal.hide('modal_bet_detail')">
            {{ $t('Bao.confirm') }}
          </button>
          <!-- <button :disabled="!canShareBet" type="button" class="btn btn_transfer text-white" aria-label="Close" @click="showShareModal()">
            {{ $t('Bao.share') }}
          </button> -->
        </div>
      </template>
    </b-modal>
    <b-modal
      id="modal_confirm_share"
      ref="modal_confirm_share"
      modal-class="modal modal_bet_detail fade"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      footer-class="modal-footer justify-content-center border-top-0"
      header-class="modal-header justify-content-center align-items-center border-bottom-0"
      body-class="modal-body"
      dialog-class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md"
    >
      <template v-slot:modal-header>
        <h4 class="mb-0">
          <b>{{ $t('Bao.share') }}</b>
        </h4>
        <button type="button" class="close rounded-circle m-0" aria-label="Close" @click="$bvModal.hide('modal_confirm_share')">
          <i class="icon-clear" />
        </button>
      </template>
      <ul class="modal_bet_detail_data d-grid list-unstyled justify-content-center mb-0">
        {{ $t('Bao.share_on_chat') }}
      </ul>
      <template v-slot:modal-footer>
        <div class="wallet_transfer_btn d-flex justify-content-center w-100">
          <button type="button" class="btn btn_ok text-white" @click="confirmShare">
            {{ $t('Bao.confirm') }}
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { getGameBetStatus } from '@/api/common'
import { gameBetRecord, leaveAll, getTypeMenuInfo } from '@/api/game'
import { showNotice } from '@/utils/tool'
import { shareBetOnChat } from '@/api/user'
import ScrollLoader from 'vue-scroll-loader/src/components/Scroll-Loader'

export default {
  components: {
    ScrollLoader
  },
  data() {
    return {
      actionDoLoading: false,
      dateRange: {
        startDate: moment().subtract(3, 'd').toDate(),
        endDate: new Date()
      },
      status: 'all',
      beforeDay: 0,
      // ssummary: {},
      record: [],
      betDetail: {
        id: '',
        created_at: '',
        finish_at: '',
        game_provider_name: '',
        bet_amount: '',
        bet_result: '',
        status_label: ''
      },
      gameBetStatus: [],
      gameType: 'all',
      page: 1,
      pageSize: 50,
      enableAutoLoad: true,
      loading: false,
      firstLoad: true,
      canShareBet: true,
      selectedDay: this.$i18n.t('Bao.today'),
      showAccountQuick: false
    }
  },
  async created() {
    if (!this.$store.getters.gameType) {
      getTypeMenuInfo().then((response) => {
        this.$store.commit('SET_GAME_TYPE', response.data.data)
      })
    }

    const res = await getGameBetStatus()
    this.gameBetStatus = res.data.data
    this.oneQuery()
  },
  methods: {
    async query() {
      if (this.loading) return
      this.loading = true
      this.firstLoad = false
      const queryObj = {
        'startDate': moment().subtract(this.beforeDay, 'days').startOf('day').format('YYYY/MM/DD'),
        'endDate': moment().subtract(this.beforeDay, 'days').endOf('day').format('YYYY/MM/DD'),
        'page': this.page,
        'page_size': this.pageSize
      }
      if (this.status !== 'all') {
        queryObj.status = this.status
      }
      if (this.gameType !== 'all') {
        queryObj.game_type = this.gameType
      }
      const res = await gameBetRecord(queryObj)
      // this.summary = res.data.data.summary
      this.record = [...this.record, ...res.data.data.list]
      if (res.data.data.list.length < this.pageSize) {
        this.enableAutoLoad = false
      } else {
        this.page += 1
        this.enableAutoLoad = true
      }
      this.loading = false

      this.firstLoad = false
    },
    oneQuery() {
      this.enableAutoLoad = true
      this.page = 1
      this.record = []
      this.query()
    },
    clickGameType(game_type) {
      this.gameType = game_type
      this.enableAutoLoad = true
      this.page = 1
      this.record = []
      this.query()
    },
    showModal(item) {
      this.betDetail = item
      this.$bvModal.show('modal_bet_detail')
    },
    hideModal() {
      this.$bvModal.hide('modal_bet_detail')
    },
    showShareModal() {
      this.$bvModal.hide('modal_bet_detail')
      this.$bvModal.show('modal_confirm_share')
    },
    confirmShare() {
      const self = this

      if (this.canShareBet) {
        this.canShareBet = false
        setTimeout(function() {
          self.canShareBet = true
        }, 30000)

        const postForm = {
          betid: this.betDetail.id
        }

        shareBetOnChat(postForm).then(response => {
        }).catch((error) => {
          showNotice(error.response.data.msg)
        }).finally((e) => {
        })

        this.$emit('shareBet', this.betDetail)
      }

      this.$bvModal.hide('modal_confirm_share')
    },
    gameLeaveAll() {
      this.actionDoLoading = true
      leaveAll().then(response => {
        this.hideLeaveModal()
        showNotice(response.data.msg)
      }).finally(() => {
        this.actionDoLoading = false
      })
    },
    getOrderNumber(id) {
      var my_string = '' + id
      while (my_string.length < 10) {
        my_string = '0' + my_string
      }
      return my_string
    },
    switchDay(beforeDay, dayName) {
      this.beforeDay = beforeDay
      this.selectedDay = dayName
      this.closeAccountQuick()
      this.oneQuery()
    },
    clickToogleAccountQuick() {
      this.showAccountQuick = !this.showAccountQuick
      this.$store.state.app.hideMobileNav = !this.$store.state.app.hideMobileNav
    },
    closeAccountQuick() {
      this.showAccountQuick = false
      this.$store.state.app.hideMobileNav = false
    }
  }
}
</script>

<style>
.account_range {
  white-space: nowrap;
}
@media only screen and (max-width: 767px) {
  .account_range_date {
    width: 60px;
  }
}
</style>
